import React, { useState } from 'react';
import Modal from './Modal';
import './ConfirmEntryModal.css';

const RejectRescheduleModal = ({ onClose, onConfirm, customer_name }) => {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const handleConfirm = () => {
    const finalReason = reason === "Others" ? customReason : reason;
    if (!finalReason) {
      alert("Please select or enter a reason to reject.");
      return;
    }
    onConfirm(finalReason);
  };

  return (
    <Modal onClose={onClose}>
      <div className="confirm-entry-modal" style={{ textAlign: 'left' }}>
        <h2>Reject Reschedule</h2>
        <p>Reject the reschedule request for <strong>{customer_name}</strong>?</p>

        <div style={{ marginTop: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Reason for rejection:</label>
          <select 
            value={reason} 
            onChange={(e) => setReason(e.target.value)}
            style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
          >
            <option value="">Select a reason</option>
            <option value="We are fully booked">We are fully booked</option>
            <option value="Requested time is not available">Requested time is not available</option>
            <option value="Outside of operating hours">Outside of operating hours</option>
            <option value="Others">Others</option>
          </select>
        </div>

        {reason === "Others" && (
          <div style={{ marginTop: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Please specify:</label>
            <input 
              type="text" 
              value={customReason} 
              onChange={(e) => setCustomReason(e.target.value)}
              style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
              placeholder="Enter custom reason"
            />
          </div>
        )}

        <div className="actions" style={{ marginTop: '20px' }}>
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="confirm-button" onClick={handleConfirm}>Reject</button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectRescheduleModal;
